import { P2TextDescription } from 'react-bootstrap-common-script'

function CompletionReminderSegment() {
  return (
    <div className='polymer-stage-e-reminder px-4'>
      <P2TextDescription color='#333' title={"Completion Appointment"} description={"HDB staff will contact you for your completion appointment. Please ensure that all owners attend the completion appointment accordingly."} />
    </div>
  )
}

export default CompletionReminderSegment